import React from "react";
import { random } from "lodash";
import WantToReadButton from "../../want_to_read/want_to_read_button";
import ClickTrackingWrapper from "../../click_tracking_wrapper";
import { TRACKED_CLASSES_AUDIBLE } from "../../../modules/ads/click_tracking_helper";
import CarouselActions from "../../../react_actions/carousel_actions";

import GrComponentFactory from "../../gr_component_factory";

export default GrComponentFactory.createClass({

  displayName: "AudiobookSlide",

  propTypes: {
    bookId: React.PropTypes.string,
    title: React.PropTypes.string,
    bookAci: React.PropTypes.string,
    requestOriginUrl: React.PropTypes.string,
    randomRequestParam: React.PropTypes.string,
    imageUrl: React.PropTypes.string,
    audiobookHost: React.PropTypes.string,
    bookUrl: React.PropTypes.string,
    author: React.PropTypes.object,
    description: React.PropTypes.object,
    avgRating: React.PropTypes.number,

    //properties passed to the children describing the behavior of
    //the parent
    carouselId: React.PropTypes.string,
    currentSlide: React.PropTypes.number,
    slideIndex: React.PropTypes.number,
    slidesToShow: React.PropTypes.number,
    sidesToScroll: React.PropTypes.number,
    slideCount: React.PropTypes.number,
    slideWidth: React.PropTypes.number,
  },

  getDefaultProps () {
    return {
      trackingOptions: {
        enableTracking: true,
      },
    };
  },

  showTooltip () {
    CarouselActions.showTooltip(this.props.carouselId, this.props.slideIndex);
  },

  hideTooltip () {
    CarouselActions.hideTooltip(this.props.carouselId);
  },

  renderImage() {
    const image =
        (<a className="img-container" href={this.props.bookUrl}>
          <img src={this.props.imageUrl} />
        </a>);
    return <ClickTrackingWrapper children={image} trackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Carousel_BookImage} />;
  },

  render () {

    const wantToReadProps = {
      bookId: this.props.bookId.toString(),
      bookTitle: this.props.title,
      uniqueId: random(1000000).toString(),
      showStars: false,
      showMenu: false,
      trackingOptions: TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Carousel_WantToRead,
    };

    return (
        <div className="gr-carousel-audiobookSlide"
             onMouseEnter={this.showTooltip}
             onMouseLeave={this.hideTooltip}>

          {this.renderImage()}
          <div className="gr-carousel-wantToRead-SpacingLeft">
            <WantToReadButton
                {...wantToReadProps} />
          </div>
        </div>
    );
  },
});
